// DS: DS6.1.1
import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import s from './ListHeader.scss';

export interface Props extends HTMLAttributes<HTMLDivElement> {
  withDivider?: boolean;
}

const ListHeader: React.FC<Props> = ({ children, withDivider, className, ...rest }) => {
  return (
    <BiDiv className={c(s['root'], className)} {...rest}>
      <div className={c(!!children && s['has-content'], withDivider && s['has-divider'])}>
        {children}
      </div>
    </BiDiv>
  );
};
ListHeader.displayName = 'ListHeader';

export default ListHeader;
